<template>
  <PageContainer>
    <div class="privacy">
      <h2 class="privacy__title"><PrivacyText term-key="ctg_privacy_title" /></h2>
      <p class="privacy__effective"><PrivacyText term-key="ctg_privacy_effective" /></p>
      <p class="privacy__section">
        <PrivacyText term-key="ctg_privacy_block_3" :bold-keys="['ctg_privacy_block_3_b1']" />
      </p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_4" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_5" /></p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_6" /></h3>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_7" /></p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_8" /></h3>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_9" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_10" /></p>
      <h4 class="privacy__h4"><PrivacyText term-key="ctg_privacy_block_11" /></h4>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_12" /></p>
      <h5 class="privacy__h5"><PrivacyText term-key="ctg_privacy_block_13" /></h5>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_14" /></p>
      <p class="privacy__section privacy__section--strong"><PrivacyText term-key="ctg_privacy_block_15" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_16" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_17" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_18" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_19" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_20" /></p>
      <p class="privacy__section privacy__section--strong"><PrivacyText term-key="ctg_privacy_block_21" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_22" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_23" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_24" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_25" /></p>
      <p class="privacy__section privacy__section--strong"><PrivacyText term-key="ctg_privacy_block_26" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_27" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_28" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_29" /></p>
      <p class="privacy__section">
        <PrivacyText term-key="ctg_privacy_block_30" :bold-keys="['ctg_privacy_block_30_b1']" />
      </p>
      <p class="privacy__section">
        <PrivacyText term-key="ctg_privacy_block_31" :bold-keys="['ctg_privacy_block_31_b1']" />
      </p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_32" /></p>
      <h5 class="privacy__h5"><PrivacyText term-key="ctg_privacy_block_33" /></h5>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_34" /></p>
      <p class="privacy__section privacy__section--list">
        <PrivacyText term-key="ctg_privacy_block_35" :bold-keys="['ctg_privacy_block_35_b1']" />
      </p>
      <p class="privacy__section privacy__section--list">
        <PrivacyText term-key="ctg_privacy_block_36" :bold-keys="['ctg_privacy_block_36_b1']" />
      </p>
      <p class="privacy__section privacy__section--list">
        <PrivacyText term-key="ctg_privacy_block_37" :bold-keys="['ctg_privacy_block_37_b1']" />
      </p>
      <p class="privacy__section privacy__section--list">
        <PrivacyText term-key="ctg_privacy_block_38" :bold-keys="['ctg_privacy_block_38_b1']" />
      </p>
      <p class="privacy__section privacy__section--list">
        <PrivacyText term-key="ctg_privacy_block_39" :bold-keys="['ctg_privacy_block_39_b1']" />
      </p>
      <h5 class="privacy__h5"><PrivacyText term-key="ctg_privacy_block_40" /></h5>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_41" /></p>
      <p class="privacy__section privacy__section--list">
        <PrivacyText term-key="ctg_privacy_block_42" :bold-keys="['ctg_privacy_block_42_b1']" />
      </p>
      <p class="privacy__section privacy__section--list">
        <PrivacyText term-key="ctg_privacy_block_43" :bold-keys="['ctg_privacy_block_43_b1']" />
      </p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_44" /></p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_45" /></h3>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_46" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_47" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_48" /></p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_49" /></h3>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_50" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_51" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_52" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_53" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_54" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_55" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_56" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_57" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_58" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_59" /></p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_60" /></h3>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_61" /></p>
      <p class="privacy__section">
        <PrivacyText term-key="ctg_privacy_block_62" :bold-keys="['ctg_privacy_block_62_b1']" />
      </p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_63" /></h3>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_64" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_65" /></p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_66" /></h3>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_67" /></p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_68" /></h3>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_69" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_70" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_71" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_72" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_73" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_74" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_75" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_76" /></p>
      <p class="privacy__section">
        <PrivacyText term-key="ctg_privacy_block_77" :bold-keys="['ctg_privacy_block_77_b1']" />
      </p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_78" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_79" /></p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_80" /></h3>
      <p class="privacy__section">
        <PrivacyText term-key="ctg_privacy_block_81" :bold-keys="['ctg_privacy_block_81_b1']" />
      </p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_82" /></h3>
      <p class="privacy__section">
        <PrivacyText
          term-key="ctg_privacy_block_83"
          :bold-keys="['ctg_privacy_block_83_b1', 'ctg_privacy_block_83_b2']"
        />
      </p>
      <h3 class="privacy__h3"><PrivacyText term-key="ctg_privacy_block_84" /></h3>
      <h4 class="privacy__h4"><PrivacyText term-key="ctg_privacy_block_85" /></h4>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_86" /></p>
      <h5 class="privacy__h5"><PrivacyText term-key="ctg_privacy_block_87" /></h5>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_88" /></p>
      <div class="privacy__table-wrap">
        <table class="privacy__table">
          <tbody>
            <tr>
              <th><PrivacyText term-key="ctg_privacy_table_1_r1_c1" /></th>
              <th><PrivacyText term-key="ctg_privacy_table_1_r1_c2" /></th>
              <th><PrivacyText term-key="ctg_privacy_table_1_r1_c3" /></th>
              <th><PrivacyText term-key="ctg_privacy_table_1_r1_c4" /></th>
              <th><PrivacyText term-key="ctg_privacy_table_1_r1_c5" /></th>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r2_c1" :bold-keys="['ctg_privacy_table_1_r2_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r2_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r2_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r3_c1" :bold-keys="['ctg_privacy_table_1_r3_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r3_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r3_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r4_c1" :bold-keys="['ctg_privacy_table_1_r4_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r4_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r4_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r5_c1" :bold-keys="['ctg_privacy_table_1_r5_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r5_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r5_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r6_c1" :bold-keys="['ctg_privacy_table_1_r6_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r6_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r6_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r7_c1" :bold-keys="['ctg_privacy_table_1_r7_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r7_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r7_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r8_c1" :bold-keys="['ctg_privacy_table_1_r8_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r8_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r8_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r9_c1" :bold-keys="['ctg_privacy_table_1_r9_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r9_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r9_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r10_c1" :bold-keys="['ctg_privacy_table_1_r10_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r10_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r10_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r11_c1" :bold-keys="['ctg_privacy_table_1_r11_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r11_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r11_c5" /></td>
            </tr>
            <tr>
              <td>
                <PrivacyText term-key="ctg_privacy_table_1_r12_c1" :bold-keys="['ctg_privacy_table_1_r12_c1_b1']" />
              </td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r12_c2" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_common_no" /></td>
              <td><PrivacyText term-key="ctg_privacy_table_1_r12_c5" /></td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_89" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_90" /></p>
      <h5 class="privacy__h5">
        <PrivacyText term-key="ctg_privacy_block_91" :bold-keys="['ctg_privacy_block_91_b1']" />
      </h5>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_92" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_93" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_94" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_95" /></p>
      <h5 class="privacy__h5">
        <PrivacyText term-key="ctg_privacy_block_96" :bold-keys="['ctg_privacy_block_96_b1']" />
      </h5>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_97" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_98" /></p>
      <h5 class="privacy__h5">
        <PrivacyText term-key="ctg_privacy_block_99" :bold-keys="['ctg_privacy_block_99_b1']" />
      </h5>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_100" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_101" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_102" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_103" /></p>
      <p class="privacy__section privacy__section--list"><PrivacyText term-key="ctg_privacy_block_104" /></p>
      <p class="privacy__section">
        <PrivacyText
          term-key="ctg_privacy_block_105"
          :bold-keys="['ctg_privacy_block_105_b1', 'ctg_privacy_block_105_b2']"
        />
      </p>
      <h5 class="privacy__h5">
        <PrivacyText term-key="ctg_privacy_block_106" :bold-keys="['ctg_privacy_block_106_b1']" />
      </h5>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_107" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_108" /></p>
      <p class="privacy__section">
        <PrivacyText term-key="ctg_privacy_block_109" :bold-keys="['ctg_privacy_block_109_b1']" />
      </p>
      <p class="privacy__section">
        <PrivacyText term-key="ctg_privacy_block_110" :bold-keys="['ctg_privacy_block_110_b1']" />
      </p>
      <h5 class="privacy__h5">
        <PrivacyText term-key="ctg_privacy_block_111" :bold-keys="['ctg_privacy_block_111_b1']" />
      </h5>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_112" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_113" /></p>
      <h4 class="privacy__h4"><PrivacyText term-key="ctg_privacy_block_114" /></h4>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_115" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_116" /></p>
      <h4 class="privacy__h4"><PrivacyText term-key="ctg_privacy_block_117" /></h4>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_118" /></p>
      <p class="privacy__section"><PrivacyText term-key="ctg_privacy_block_119" /></p>
    </div>
  </PageContainer>
</template>

<script lang="ts" setup>
import { computed, defineComponent, h, type PropType, type VNode } from 'vue';
import PageContainer from '@components/PageContainer/PageContainer.vue';
import { copyText } from '@utils/copyText';
import { isApp } from '@utils/is';
import { t } from './utils/tool';

const privacyEmailAddress = computed(() => t('ctg_privacy_email').trim());
const privacyEmailMailtoHref = computed(() =>
  privacyEmailAddress.value ? `mailto:${privacyEmailAddress.value}` : '#',
);

async function copyPrivacyEmail(): Promise<void> {
  if (!privacyEmailAddress.value) return;
  await copyText(privacyEmailAddress.value);
}

function handlePrivacyEmailClick(event: MouseEvent): void {
  if (!isApp()) return;
  event.preventDefault();
  copyPrivacyEmail();
}

const PrivacyText = defineComponent({
  name: 'PrivacyText',
  props: {
    termKey: {
      type: String,
      required: true,
    },
    boldKeys: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const text = computed(() => t(props.termKey));

    function renderEmailLink(key: string): VNode {
      return h(
        'a',
        {
          key,
          href: privacyEmailMailtoHref.value,
          class: 'privacy__link',
          onClick: handlePrivacyEmailClick,
        },
        t('ctg_privacy_email'),
      );
    }

    function renderTextWithReplacements(rawText: string, boldKeys: string[], keyPrefix: string): (VNode | string)[] {
      const nodes: (VNode | string)[] = [];
      rawText.split(/(%EMAIL%|%BOLD\d+%)/g).forEach((part, index) => {
        if (!part) return;
        if (part === '%EMAIL%') {
          nodes.push(renderEmailLink(`${keyPrefix}-email-${index}`));
          return;
        }
        const boldMatch = part.match(/^%BOLD(\d+)%$/);
        if (boldMatch) {
          const boldKey = boldKeys[Number(boldMatch[1]) - 1];
          if (boldKey) {
            nodes.push(
              h(
                'b',
                { key: `${keyPrefix}-bold-${index}` },
                renderTextWithReplacements(t(boldKey), [], `${keyPrefix}-bold-${index}`),
              ),
            );
          }
          return;
        }
        nodes.push(part);
      });
      return nodes;
    }

    return () => renderTextWithReplacements(text.value, props.boldKeys, 'text');
  },
});
</script>

<style lang="less" scoped>
.privacy {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 24px 16px;
  box-sizing: border-box;
  color: @---B-100;

  &__title {
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    text-align: center;
    margin-bottom: 8px;
  }

  &__effective {
    text-align: end;
    font-size: 12px;
    margin-bottom: 12px;
  }

  &__h3 {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.35;
    margin-top: 16px;
    margin-bottom: 8px;
  }

  &__h4 {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    margin-top: 12px;
    margin-bottom: 6px;
  }

  &__h5 {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
    margin-top: 10px;
    margin-bottom: 6px;
  }

  &__section {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.55;
    margin-bottom: 10px;
    white-space: pre-wrap;
  }

  &__section--strong {
    font-weight: 600;
  }

  &__section--list {
    padding-left: 12px;
  }

  &__table-wrap {
    width: 100%;
    overflow-x: auto;
    margin: 8px 0 12px;
  }

  &__table {
    width: 100%;
    min-width: 860px;
    border-collapse: collapse;
    color: @---B-100;
    font-size: 12px;
    line-height: 1.45;

    th,
    td {
      border: 1px solid rgba(18, 16, 16, 0.18);
      padding: 8px;
      text-align: left;
      vertical-align: top;
      white-space: pre-wrap;
    }

    th {
      font-weight: 600;
      background: rgba(18, 16, 16, 0.04);
    }
  }

  :deep(.privacy__link) {
    color: var(--color-brand, #ff5353);
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
